
import Passenger from '@/models/Passenger'
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import StyledSelectPaxTraveling from '@/styled-components/pages/search-and-select-passengers/selectPaxTraveling'
import ItemOfVoucher from '@/components/ItemOfVoucher/Index.vue'
import { PassengerType } from '@/types/passenger'
import store from '@/store'
import LangMixinsVue from '../SearchAndSelectPassengers/Mixin/LangMixins.vue'
import { ElNotification } from 'element-plus'
import { StoreType } from '@/types/store'
import { useStore } from 'vuex'
import SearchPaxMixinsVue from './Mixin/SearchPaxMixins.vue'

export default defineComponent({
  name: 'SelectPaxTraveling',
  components: {
    StyledSelectPaxTraveling,
    ItemOfVoucher
  },
  mixins: [SearchPaxMixinsVue, LangMixinsVue],
  props: {
    listGroupPaxs: {
      type: Array as PropType<PassengerType[]>,
      default: () => []
    },
    myId: {
      type: Number,
      require: true,
      default: undefined
    },
    listSelectedGroupPaxIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['updateStep'],
  setup() {
    const store = useStore<StoreType>()
    return {
      listMyGroupPaxs: computed(() => store.getters['groupPax/listGroupPax'])
    }
  },
  data() {
    let listGroupPaxsExcludeMe: any[] = []
    if (this.listSelectedGroupPaxIds.length > 0) {
      listGroupPaxsExcludeMe = this.listGroupPaxs.filter(
        (pax: any) => this.listSelectedGroupPaxIds.includes(pax.id) && pax.id != this.myId
      )
    } else {
      listGroupPaxsExcludeMe = this.listGroupPaxExcludeMe(this.listGroupPaxs, this.myId)
    }

    const listNewGroupPaxsExcludeMeIds = listGroupPaxsExcludeMe.map((pax) => pax.id)
    return {
      router: useRouter(),
      listGroupPaxsExcludeMe,
      listNewGroupPaxsExcludeMeIds
    }
  },
  computed: {
    addPassengerText() {
      return this.groundHandlerMessage?.search_and_select_pax.SFS_LANG_ROW_17 || 'Add Passenger'
    },
    pnrText() {
      return this.groundHandlerMessage?.search_and_select_pax.SFS_LANG_ROW_29 || 'PNR:'
    },
    travelingWithText() {
      return this.groundHandlerMessage?.search_and_select_pax.SFS_LANG_ROW_18 || 'Traveling with'
    }
  },
  methods: {
    backStep() {
      if (this.listGroupPaxs.length <= 9) this.$emit('updateStep', 'areYouTravelingAlone')
      else this.$emit('updateStep', 'addMorePax')
    },
    async handleConfirm() {
      const passenger = new Passenger()

      const listNewGroupPaxsIncludeMeIds = [...this.listNewGroupPaxsExcludeMeIds, this.myId]

      ElNotification.closeAll()
      if (listNewGroupPaxsIncludeMeIds.length <= 1) {
        ElNotification({
          title: 'Error',
          message: 'Please add or select at least one passenger',
          type: 'error',
          duration: 3000
        })
        return
      }

      const { success } = await passenger.addNewPaxsToGroup({
        passenger_id: store.state.groupPax.me?.passenger_id || store.state.groupPax.me?.id || 0,
        flight_id: store.state.flightInfo?.flight_id || store.state.flightInfo?.id,
        passengers: this.listNewGroupPaxsExcludeMeIds.map((id) => {
          const pax = this.listGroupPaxsExcludeMe.find((pax) => pax.id == id)
          return { pnr: pax.pnr || '', first_name: pax.first_name || '', last_name: pax.last_name || '' }
        })
      })
      if (success) {
        this.router.push({ name: 'Home' })
      }
    }
  }
})
